import React from "react";
import classNames from "classnames";
import replaceContent from "../../helpers/replacers";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: string;
  className?: string;
}

const Wysiwyg = ({ children, className, ...props }: Props) => {
  return (
    <div
      {...props}
      id="content"
      className={classNames(className, "wysiwyg mx-auto dark:wysiwyg-invert")}
    >
      {children ? replaceContent(children) : null}
    </div>
  );
};

export default Wysiwyg;
